/// <reference types="./sampleEntities.d.ts" />
import { ok, } from '@dossierhq/core';
import { queryMany } from '../QueryFunctions.js';
import { samplePublishedEntitiesQuery, } from '../search/QueryGenerator.js';
import { assertIsDefined } from '../utils/AssertUtils.js';
import { resolveEntityFields, resolvePublishedEntityInfo } from '../utils/CodecUtils.js';
export async function publishedEntitySampleEntities(database, schema, context, query, offset, limit, resolvedAuthKeys) {
    const sqlQueryResult = samplePublishedEntitiesQuery(schema, query, offset, limit, resolvedAuthKeys);
    if (sqlQueryResult.isError())
        return sqlQueryResult;
    const searchResult = await queryMany(database, context, sqlQueryResult.value);
    if (searchResult.isError())
        return searchResult;
    const entitiesValues = searchResult.value;
    return ok(entitiesValues.map((it) => {
        assertIsDefined(it.uuid);
        return {
            ...resolvePublishedEntityInfo(it),
            ...resolveEntityFields(it),
            id: it.uuid,
        };
    }));
}
//# sourceMappingURL=sampleEntities.js.map